export const ICandidateNotifications = Object.freeze({
  incomingJob: "total_incoming_job",
  cdiSelected: "total_cdi_selected",
  unseenCdiOffer: "total_unviewed_cdi",
  unseenExtraOffer: "total_unviewed_extra",
  additionalFileRequired: "kyc_additional_file_required",
  kycActivationRequired: "kyc_activation_required",
});

export class CandidateNotificationsModel {
  constructor(data = {}) {
    this[ICandidateNotifications.incomingJob] = data[ICandidateNotifications.incomingJob];
    this[ICandidateNotifications.cdiSelected] = data[ICandidateNotifications.cdiSelected];
    this[ICandidateNotifications.unseenCdiOffer] = data[ICandidateNotifications.unseenCdiOffer];
    this[ICandidateNotifications.unseenExtraOffer] = data[ICandidateNotifications.unseenExtraOffer];
    this[ICandidateNotifications.additionalFileRequired] = data[ICandidateNotifications.additionalFileRequired];
    this[ICandidateNotifications.kycActivationRequired] = data[ICandidateNotifications.kycActivationRequired];
  }

  getIncomingJob() {
    return this[ICandidateNotifications.incomingJob];
  }

  getCdiSelected() {
    return this[ICandidateNotifications.cdiSelected];
  }

  getUnseenCdiOffer() {
    return this[ICandidateNotifications.unseenCdiOffer];
  }

  getUnseenExtraOffer() {
    return this[ICandidateNotifications.unseenExtraOffer];
  }

  hasIncomingJob() {
    return this.getIncomingJob() > 0;
  }

  hasCdiSelected() {
    return this.getCdiSelected() > 0;
  }

  hasUnseenCdiOffer() {
    return this.getUnseenCdiOffer() > 0;
  }

  hasUnseenExtraOffer() {
    return this.getUnseenExtraOffer() > 0;
  }

  hasNotifications() {
    return this.hasIncomingJob() || this.hasCdiSelected() || this.hasUnseenCdiOffer() || this.hasUnseenExtraOffer();
  }

  isAdditionalFileRequired() {
    return this[ICandidateNotifications.additionalFileRequired];
  }

  isKycActivationRequired() {
    return this[ICandidateNotifications.kycActivationRequired];
  }
}
